export default "__VITE_ASSET__BNkycdcb__"